<template>
<div>
 <div class="header">
        <div class="left_header">
                    <div @click="$router.push('/index_m')" class="logo"><img src="https://oss.mifengbangzu.com/web/index/index_logo.png?x-oss-process=image/resize,p_30"></div>
        </div> 
        <el-menu  :default-active="$route.path"  class="right_header" background-color="#f5f7fa00"
          mode="horizontal" @select="handleSelect"  text-color="#fff" active-text-color="#ffd04b">
          <el-menu-item index="/index_m">首页</el-menu-item>
          <el-menu-item index="/house_m">找房</el-menu-item>
          <el-submenu     index="3"  mode="horizontal">
              <template slot="title">公寓产品</template>
              <el-menu-item  index="/huayi_m"  :class="isTop?'':'zi'">华宜建筑装饰</el-menu-item>
              <el-menu-item  index="/weige_m" :class="isTop?'':'zi'">维格家具装饰</el-menu-item>
              <el-menu-item  index="/bangju_m" :class="isTop?'':'zi'">邦居公寓</el-menu-item>
          </el-submenu>
          <el-menu-item index="/xitong_m" >系统</el-menu-item>
          <el-menu-item index="/jiameng_m">合作</el-menu-item>
        </el-menu>
 </div>
 <div class="zw"></div>
 </div>
</template>
<script>
  export default {
  	name: "MobileHeader",
    data() {
        return {
            activeIndex:"",isTop:true,
        };
    },
   created() {
            this.activeIndex=this.$route.path;
            window.addEventListener("scroll",this.jt);
    },
   methods: {

            handleSelect:function(e,k){
      
               if(["/index_m","/xitong_m","/jiameng_m"].includes(e)){
                    this.$router.push({path:e});
               }
               if(e=="/house_m"){
                location.href="https://h5.mifengbangzu.com/";
               }
              if(["/huayi_m","/weige_m","/bangju_m"].includes(e)){
         
                 this.$router.push({path:e});
                 
                 
              }
            },
            jt:function(e){
               this.isTop=$(window).scrollTop()==0?true:false;
            },
    },
  }
</script>
<style lang="scss" scoped>
.zi{
    color: #097bed !important;
 }
 .zw{
  height: 1.2rem;
 }
.header{
    position:fixed; top: 0rem;left:0rem; width: 100%; z-index: 999; display: flex; box-shadow: 0rem 0.01rem 0.27rem 0rem rgba(11,3,6,0.51);
    background-color: #090a0a;
    .left_header{
        width: 2rem;
        height: 1rem;
        display: flex;
        align-items: center;
        padding-left: 0.1rem;
        .logo{
            cursor: pointer;
            img{
               height: 0.4rem;
               width:2rem;
            }
        }
    }
    .right_header{
        width: 5.5rem;
        padding-left: 0.2rem;
        display: flex;
        /deep/ .el-menu-item{
        font-size: 0.18rem;
        padding: 0rem 0.2rem !important;
       } 
       /deep/  .el-submenu__title{
        font-size: 0.18rem !important;
        padding: 0rem 0.2rem !important;
       }
       /deep/ .el-menu-item.is-active,/deep/ .el-submenu.is-active .el-submenu__title{
        color: #11934e !important;
        border-bottom-color:#11934e !important;
       }
       
    }
    /deep/ .el-menu.el-menu--horizontal{
        border-bottom:unset !important;
     }

}
</style>


// WEBPACK FOOTER //
// src/layouts/MobileHeader/index.vue